import { User } from "firebase/auth";
import { atom } from "jotai";
import { atomWithQuery } from "jotai-tanstack-query";
import { getUserData, userMetadataQuery } from "./_actions-server/user";

export const initialUserAtom = atom<User | null>(null)

export const authUserAtom = atom<User | null>(null);

export const userAtom = atomWithQuery((get) => ({
    queryKey: ['getUserData', get(authUserAtom)?.uid],
    queryFn: getUserData
}));

// export const userMetadataAtom = atomWithQuery((get) => ({
//     queryKey: ['userMetadataQuery', get(authUserAtom)?.uid],
//     queryFn: userMetadataQuery,
//     enabled: !!get(authUserAtom)
// }));

export const sessionAtom = atom<any>(null)

export const isUserAdmin = atom<boolean>(false)

const global = {
    // userAtom,
    sessionAtom,
    isUserAdmin,
}

export default global